import { render, staticRenderFns } from "./create-request-item.vue?vue&type=template&id=be02e12c&scoped=true"
import script from "./create-request-item.vue?vue&type=script&lang=js"
export * from "./create-request-item.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./create-request-item.vue?vue&type=style&index=1&id=be02e12c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be02e12c",
  null
  
)

export default component.exports